import * as React from 'react'
import { useIntl } from 'react-intl'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import { CircularProgress } from '@mui/material'

interface Props {
    open: boolean
    setOpen: (open: boolean) => void
    confirmAction: () => void
    loading?: boolean
    contentText?: string
    confirmButtonTitle?: string
}

const ConfirmActionDialog: React.FC<Props> = ({
    open,
    loading = false,
    setOpen,
    confirmAction,
    confirmButtonTitle,
    contentText,
}) => {
    const { formatMessage } = useIntl()

    const handleClose = () => {
        setOpen(false)
    }

    return (
        <Dialog
            maxWidth={'sm'}
            fullWidth
            open={open}
            onClose={handleClose}
        >
            <DialogTitle id="responsive-dialog-title">
                Подтверждение
            </DialogTitle>
            <DialogContent>
                <DialogContentText>{contentText}</DialogContentText>
            </DialogContent>

            <DialogActions sx={{ m: 2 }}>
                <Button 
                    onClick={handleClose} 
                    disabled={loading}
                >
                    {formatMessage({ id: 'cancel' })}
                </Button>

                <Button
                    disabled={loading}
                    variant="contained"
                    color={'error'}
                    onClick={confirmAction}
                >
                    {loading && <CircularProgress size={16} sx={{mr: 1}}/>} {confirmButtonTitle || formatMessage({ id: 'yes' })}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default ConfirmActionDialog
